import { NgModule } from '@angular/core';
import { LayoutRoutingModule } from './layout-routing.module';
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { NavbarComponent } from './navbar/navbar.component';
import { HelpSidebarComponent } from './help-sidebar/help-sidebar.component';

@NgModule({
    imports: [
        LayoutRoutingModule,
        HeaderComponent,
        SidebarComponent,
        NavbarComponent,
        HelpSidebarComponent,
    ],
    exports: [HeaderComponent, SidebarComponent, HelpSidebarComponent],
})
export class LayoutModule {}
